import React, { useEffect } from "react";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import MuiTableHead from "@material-ui/core/TableHead";
// import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/landingPage/Header";
import SideBar from "../../../components/b2b/SideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
} from "@fortawesome/fontawesome-free-solid";
import {
  setPageNext,
  setPagePrev,
} from "../../../redux/app/booking/booking-slice";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { Link } from "react-router-dom";

const columns = [
  { id: "FileId", label: "File\u00a0Id", minWidth: 90 },
  { id: "BookingId", label: "Booking\u00a0Id", minWidth: 120 },
  {
    id: "TravelDate",
    label: "Travel\u00a0Date",
    minWidth: 90,
    align: "right",
  },
  {
    id: "BookingType",
    label: "Booking\u00a0Type",
    minWidth: 90,
    align: "right",
    // format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "Client",
    label: "Client",
    minWidth: 90,
    align: "right",
  },
  {
    id: "Supplier",
    label: "Supplier",
    minWidth: 90,
    align: "right",
  },

  {
    id: "spcurrency",
    label: "SP\u00a0Currency",
    minWidth: 90,
    align: "right",
  },
  {
    id: "spunit",
    label: "SP",
    minWidth: 90,
    align: "right",
  },
  {
    id: "ppcurrency",
    label: "PP\u00a0Currency",
    minWidth: 90,
    align: "right",
  },
  {
    id: "ppunit",
    label: "PP\u00a0Unit",
    minWidth: 90,
    align: "right",
  },

  {
    id: "paxName",
    label: "Pax\u00a0Name",
    minWidth: 90,
    align: "right",
  },
];

function createData(
  FileId,
  BookingId,
  TravelDate,
  BookingType,
  Client,
  Supplier,
  spunit,
  spcurrency,
  ppunit,
  ppcurrency,
  paxName
) {
  return {
    FileId,
    BookingId,
    TravelDate,
    BookingType,
    Client,
    Supplier,
    spunit,
    spcurrency,
    ppunit,
    ppcurrency,
    paxName,
  };
}

const Dockets = () => {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState();
  const { token } = useSelector((state) => state.auth);
  const { allBookings, pageCount, totalBookingCount, search } = useSelector(
    (state) => state.booking
  );

  useEffect(() => {
    dispatch({
      type: "TOTAL_BOOKING_COUNT",
      payload: { token: token },
    });
    if (
      search?.bookingId ||
      search?.createdDateStart ||
      search?.createdDateEnd ||
      search?.travelStartDate ||
      search?.travelEndDate ||
      search?.companyName ||
      search?.userName ||
      search?.passengerName ||
      search?.bookingStatus ||
      search?.paymentStatus
    ) {
      dispatch({
        type: "GET_ALL_BOOKINGS",
        payload: { token: token, search: search },
      });
    } else {
      dispatch({
        type: "GET_ALL_BOOKINGS",
        payload: { token: token, pageCount: pageCount },
      });
    }
  }, [pageCount, dispatch, token]);

  let rows = [];

  useEffect(() => {
    allBookings?.forEach((booking) => {
      rows.push(
        createData(
          booking?.fileId,
          booking?.bookingId,
          booking?.travelDate,
          booking?.bookingType,
          booking?.bookingFor,
          booking?.affiliateDetails?.affiliateName,
          booking?.priceDetails?.amount,
          booking?.priceDetails?.currency,
          booking?.purchasePrice,
          booking?.purchaseCurrency,
          booking?.passengerDetails?.firstName +
            " " +
            booking?.passengerDetails?.lastName
        )
      );
    });
  }, [allBookings]);

  return (
    <div className="fixed w-screen h-screen ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen h-screen overflow-y-auto">
          <Paper sx={{ width: "90%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead
                  sx={{
                    backgroundColor: "#EFEFEF",
                  }}
                >
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allBookings
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((booking) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={booking?.bookingId}
                        >
                          <TableCell
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.fileId}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "12px",
                              color: "blue",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            <Link to={`/manageBooking/${booking?.bookingId}`}>
                              {booking?.bookingId}
                            </Link>
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {moment(booking?.travelDate).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.bookingType}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.bookingFor}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.affiliateDetails?.affiliateName}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.priceDetails?.currency}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.priceDetails?.amount}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.purchaseCurrency}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.purchasePrice}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontSize: "12px",
                            }}
                            className="border "
                            // key={column.id}
                            // align={column.align}
                          >
                            {booking?.passengerDetails?.firstName +
                              " " +
                              booking?.passengerDetails?.lastName}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="flex space-x-3 justify-end lg:justify-end lg:px-3 px-10">
              <div className=" font-body">
                Page: {pageCount} / {Math.ceil(totalBookingCount / 10)}
              </div>
              <div
                onClick={() => {
                  pageCount > 1 && dispatch(setPagePrev());
                }}
                className={`flex  space-x-2 items-center ${
                  pageCount > 1 ? "cursor-pointer" : "text-gray-600"
                }  `}
              >
                <FontAwesomeIcon
                  icon={faArrowAltCircleLeft}
                  className={`flex  space-x-2 items-center ${
                    pageCount > 1 ? "cursor-pointer" : "text-gray-600"
                  }  `}
                />
                <div className="font-body">Prev</div>
              </div>

              <div
                onClick={() => {
                  pageCount < Math.ceil(totalBookingCount / 10) &&
                    dispatch(setPageNext());
                }}
                className={`flex space-x-2 items-center ${
                  pageCount < Math.ceil(totalBookingCount / 10)
                    ? "cursor-pointer"
                    : " text-gray-600"
                }  `}
              >
                <div className="font-body">Next</div>
                <FontAwesomeIcon
                  icon={faArrowAltCircleRight}
                  className={`flex space-x-2 items-center ${
                    pageCount < Math.ceil(totalBookingCount / 10)
                      ? "cursor-pointer"
                      : " text-gray-600"
                  }  `}
                />
              </div>
            </div>
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default Dockets;
